import React from 'react';
import { Route, Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, ...rest }) => {
  const isAuth = localStorage.getItem('token');
  
  if (!isAuth) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that location after they log in, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/" state={{ from: rest.location }} replace />;
  }

  return children ? children : <Route {...rest} />;
};

export default ProtectedRoute;
